import BaseDataObject from './BaseDataObject';
import JockeyTrainer from './JockeyTrainer';

export default class JockeyInformation extends BaseDataObject {
  constructor(data) {
    super(Array.isArray(data) ? { jockeys: data } : data);
  }

  getJockeys() {
    return this.getObjects('jockeys', JockeyTrainer);
  }

  getJockey(index) {
    return this.getObject('jockeys', JockeyTrainer, index);
  }

  getNumberOfJockeys() {
    return this.getNumberOf('jockeys');
  }

  getJockeyWithID(id) {
    if (!this.jockeysByID) {
      this.jockeysByID = {};

      const numberOfJockeys = this.getNumberOfJockeys();
      for (let n = 0; n < numberOfJockeys; n++) {
        const jockey = this.getJockey(n);
        this.jockeysByID[jockey.getID()] = jockey;
      }
    }

    return this.jockeysByID[id];
  }
}
